export enum CraConditionScores {
    LowRisk = 1,
    BelowAverageRisk = 2,
    AboveAverageRisk = 3,
    HighRisk = 4,
}
